import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const SzHeader = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            current: PropTypes.number,
        };
        render() {
            const { content, current } = this.props;
            const navLi = content.map((item, index) => {
                if (index === current) {
                    return (
                        <li key={index} className={styles.current}>
                            <a href={item.url}>
                                {item.title}
                                <span>{item.subTitle}</span>
                            </a>
                        </li>
                    );
                } else {
                    return (
                        <li key={index}>
                            <a href={item.url}>
                                {item.title}
                                <span>{item.subTitle}</span>
                            </a>
                        </li>
                    );
                }
                // return (
                //     <li key={index} onClick={() => clickHandle(index)}>
                //         {item.title}
                //     </li>
                // );
            });

            return (
                <div className={styles.nav}>
                    <ul className={styles.clearfix}>{navLi}</ul>
                </div>
            );
        }
    },
);

export { SzHeader };
export default SzHeader;
